let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page765_game2/img/bcg.jpg',
    pos: {
      x: 584,
      y: 0,
    },
    width: 751,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page765_game2/audio/56_canary.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 129,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/54_hamster.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 258,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/47_pepper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 384,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/52_mouse.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 507,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/46_lemon.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 634,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/50_dog.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 757,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/43_banana.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 866,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/49_tomato.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 126,
        x: 1203,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/55_parrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 249,
        x: 1206,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/48_carrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 382,
        x: 1212,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/53_fish.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 506,
        x: 1215,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/45_cherry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 638,
        x: 1220,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/51_cat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 751,
        x: 1225,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game2/audio/44_pear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game2/img/audioOn.png', iconOff: 'games/page765_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 869,
        x: 1228,
      },
      unit: 'px',
    },
  ],
};

export default elements;
